import type { SVGProps } from 'react';

const SvgIconikShield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M9.73 9.42c-.45-.16-1.62-.51-2.99-.11-2.22.65-3.08 2.7-3.2 2.98.08.46.19.92.35 1.39 1.27 3.88 4.64 6.03 6.42 6.96a7.7 7.7 0 0 1-1.57-2.24c-1.85-4.05.61-8.35.99-8.98m10.76-1.93c-.21.79-.57 1.66-1.15 2.48-2.58 3.63-7.54 3.65-8.27 3.64.09.47.37 1.66 1.4 2.64 1.67 1.6 3.88 1.32 4.18 1.28.35-.3.7-.63 1.03-1 2.73-3.04 2.89-7.04 2.82-9.04zM6.7 5.02c4.43.45 6.89 4.75 7.25 5.4.37-.31 1.26-1.14 1.6-2.52.56-2.24-.77-4.03-.95-4.27-.43-.16-.89-.3-1.38-.4-3.99-.87-7.55.96-9.25 2.02.8-.21 1.72-.32 2.73-.22z"
    />
    <path
      fill="currentcolor"
      d="M16.38 8.86c-1.08 2.77-3.77 3.59-4.08 3.67.6-.05 3.5-.34 5.58-2.8 1.35-1.6 1.68-3.32 1.78-4.09-.42-.33-.96-.7-1.63-1.03-.71-.36-1.37-.59-1.91-.73.17.35 1.21 2.51.24 4.98zm-8.85-.82c2.95-.43 4.98 1.5 5.21 1.73-.34-.5-2.02-2.88-5.19-3.47-2.05-.38-3.72.18-4.44.47a9.5 9.5 0 0 0-.09 1.92c.04.79.16 1.48.3 2.02.21-.32 1.59-2.29 4.21-2.67m3.72 8.5c-1.86-2.32-1.22-5.05-1.14-5.37-.26.55-1.46 3.2-.37 6.23a7.9 7.9 0 0 0 2.65 3.59c.5-.2 1.08-.49 1.71-.89.67-.43 1.19-.89 1.59-1.28-.39-.02-2.78-.21-4.44-2.28"
    />
  </svg>
);
export default SvgIconikShield;
